module.exports = __webpack_public_path__ + "img/主画面.81a28499.png";